/**
 * 英文
 */
export default {
  message: {
    hello: 'hello world'
  }
}



// WEBPACK FOOTER //
// ./src/assets/script/i18n/en.js